module.exports = __webpack_public_path__ + "static/img/beian.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/beian.png
// module id = xlSx
// module chunks = 27